// 接口请求地址
export const BASE_URL = 'https://gaoyixia.hdlkeji.com';
// export const BASE_URL = 'https://h5.gyxqcdz.com/index.php';
// export const BASE_URL = 'https://test.gyxqcdz.com/';

// 微信appid
export const WX_APP_ID = 'wx0e0d8974cb91fafe';

// UrlScheme
export const SCHEME_IOS = 'gotit2782015695';
export const SCHEME_ANDRIOD = 'app';

// 视频可上传的文件类型
export const VIDEO_UPLOAD_FILE_TYPE = 'video/*';

// 图文可上传的文件类型
export const IMAGE_TEXT_UPLOAD_FILE_TYPE = '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pdf,.zip';

// 资料可上传的文件类型
export const INFORMATION_UPLOAD_FILE_TYPE = '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pdf,.zip';

// 资料可预览的文件类型
export const INFORMATION_PREVIEWABLE_FILE_TYPE = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'pdf'];

// 图标
export const ICON = {
    ['doc']: require('../assets/icon-13.png'),
    ['ppt']: require('../assets/icon-14.png'),
    ['pdf']: require('../assets/icon-15.png'),
    ['xls']: require('../assets/icon-16.png'),
    ['zip']: require('../assets/icon-13.png'),
    ['doc_bg']: require('../assets/icon-19.png'),
    ['ppt_bg']: require('../assets/icon-20.png'),
    ['pdf_bg']: require('../assets/icon-22.png'),
    ['xls_bg']: require('../assets/icon-21.png'),
    ['zip_bg']: require('../assets/icon-24.png'),
    ['folder_bg']: require('../assets/icon-23.png'),
};

// 资料模块图标
export const INFORMATION_ICON = {
    // word文件
    ['doc']: ICON.doc,
    ['docx']: ICON.doc,
    ['doc_bg']: ICON.doc_bg,
    ['docx_bg']: ICON.doc_bg,
    // ppt文件
    ['ppt']: ICON.ppt,
    ['pptx']: ICON.ppt,
    ['ppt_bg']: ICON.ppt_bg,
    ['pptx_bg']: ICON.ppt_bg,
    // xls表格文件
    ['xls']: ICON.xls,
    ['xlsx']: ICON.xls,
    ['xls_bg']: ICON.xls_bg,
    ['xlsx_bg']: ICON.xls_bg,
    // ptf文件
    ['pdf']: ICON.pdf,
    ['pdf_bg']: ICON.pdf_bg,
    // zip压缩包文件
    ['zip']: ICON.zip,
    ['zip_bg']: ICON.zip_bg,
    // 文件夹
    ['folder_bg']: ICON.folder_bg,
};
